/**
 * 修补 Element UI Dialog：大量页面的 before-close 只改 visible、不调用 done()，
 * 导致 PopupManager 遮罩层(v-modal)残留。
 * <p>
 * 不用只依赖 handleClose + nextTick（异步 beforeClose 时 visible 仍可能为 true）；
 * 额外 watch visible：无论同步/异步关掉，只要最终 visible=false 就补 hide() 清栈。
 */
let dialogPatchApplied = false;

/**
 * Vue 2 watcher 可为函数、方法名字符串、或 { handler, deep, immediate }。
 * handler 也可能是方法名字符串；必须解析成函数再 call，否则会 TypeError。
 */
function resolveWatchHandler(handler, ctx) {
  if (typeof handler === "function") {
    return handler;
  }
  if (typeof handler === "string" && ctx && typeof ctx[handler] === "function") {
    return ctx[handler];
  }
  return null;
}

function invokePreviousVisibleWatch(prev, ctx, val) {
  if (!prev) {
    return;
  }
  if (typeof prev === "function" || typeof prev === "string") {
    const fn = resolveWatchHandler(prev, ctx);
    if (fn) {
      fn.call(ctx, val);
    }
    return;
  }
  if (Array.isArray(prev)) {
    prev.forEach((item) => invokePreviousVisibleWatch(item, ctx, val));
    return;
  }
  const fn = resolveWatchHandler(prev.handler, ctx);
  if (fn) {
    fn.call(ctx, val);
  }
}

export function patchElementDialog(Vue) {
  if (dialogPatchApplied) {
    return;
  }

  const ElDialog = Vue.options.components.ElDialog;
  if (!ElDialog || !ElDialog.options || !ElDialog.options.methods) {
    return;
  }

  dialogPatchApplied = true;

  const originalHandleClose = ElDialog.options.methods.handleClose;

  ElDialog.options.methods.handleClose = function patchedHandleClose() {
    if (typeof this.beforeClose !== "function") {
      return originalHandleClose.call(this);
    }

    let doneCalled = false;
    const done = (cancel) => {
      doneCalled = true;
      this.hide(cancel);
    };

    this.beforeClose(done);

    // 同步路径：beforeClose 已把 visible 设为 false 但未调 done
    if (!doneCalled && !this.visible) {
      this.hide();
    }
  };

  const previousVisibleWatch =
    ElDialog.options.watch && ElDialog.options.watch.visible;

  ElDialog.options.watch = Object.assign({}, ElDialog.options.watch, {
    visible(val) {
      invokePreviousVisibleWatch(previousVisibleWatch, this, val);
      // 异步关闭也会落到这里，保证遮罩栈被清理
      if (val === false && typeof this.hide === "function") {
        this.$nextTick(() => {
          this.hide();
        });
      }
    },
  });
}
